import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { papi } from "@/lib/pizzeria";

const SettingsContext = createContext(null);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState(null);
  const [payments, setPayments] = useState(null);
  const [featured, setFeatured] = useState(null);
  const [promos, setPromos] = useState([]);
  const [error, setError] = useState(false);

  const load = () => {
    setError(false);
    papi.get("/settings").then(({ data }) => setSettings(data)).catch(() => setSettings({}));
    papi.get("/categories").then(({ data }) => setCategories(data)).catch(() => {});
    papi.get("/products").then(({ data }) => setProducts(data.filter((p) => p.available !== false))).catch(() => {
      setError(true);
      setProducts([]);
    });
    papi.get("/payments/config").then(({ data }) => setPayments(data)).catch(() => setPayments({ enabled: false }));
    papi.get("/featured").then(({ data }) => setFeatured(data)).catch(() => {});
    papi.get("/promotions").then(({ data }) => setPromos(Array.isArray(data) ? data : [])).catch(() => {});
  };

  useEffect(() => {
    load();
  }, []);

  const deals = useMemo(() => ({ featured, promos }), [featured, promos]);
  return <SettingsContext.Provider value={{ settings, categories, products, payments, featured, promos, deals, error, reload: load }}>{children}</SettingsContext.Provider>;
}

export const useShop = () => useContext(SettingsContext);
